import { fmtCompact, fmtPct, fmtShare } from '../utils/fmt';
import { LocalSaveMenu } from './LocalStatusBar';
import { openLanding } from '../utils/landing';
import { PLUSZ_PATH } from '../utils/pricing';
import TrialStartButton from './TrialStart';
import { TAG_LESSONS } from '../utils/leckeszam';

/* trial_days_left is 0 on the last day (get_user_access rounds down while
   trial_active is still true) — say "Ma lejár" instead of "0 nap". */
export function trialDaysText(days) {
  return days > 0 ? `Próba: ${days} nap` : 'Próba: ma lejár';
}

export default function Header({ globalData, theme, onToggleTheme, onMenuToggle, onSignOut, userEmail, access, user, onTagClick, tagPending, onAlertsClick, alertsBadge = 0, onTrialStarted }) {
  const d = globalData?.data;
  const totalMktCap = d?.total_market_cap?.usd;
  const btcDominance = d?.market_cap_percentage?.btc;
  const ethDominance = d?.market_cap_percentage?.eth;
  const volume24h = d?.total_volume?.usd;
  const mktCapChange = d?.market_cap_change_percentage_24h_usd;
  const displayEmail = userEmail
    ? (userEmail.length > 24 ? userEmail.slice(0, 24) + '…' : userEmail)
    : '';

  /* Korábban query paraméterrel küldte a tokent, amit a landing SEHOL nem
     olvasott — az átadás tehát sosem működött, a felhasználó kijelentkezve
     érkezett meg. Ráadásul a window.open egy await UTÁN futott, amit a
     popup-blokkoló megfog. Mindkettőt az openLanding helper kezeli. */
  /* FREE és TAG: a fő ajánlat a Plusz (Plusz 3. kör); Plusz-előfizetőnek a PRO. */
  const goPlusz = () => openLanding(PLUSZ_PATH, {
    user,
    event: 'plusz_cta_click',
    eventProps: { hely: 'terminal_fejlec' },
  });
  const goPro = (placement) => openLanding('/pro', {
    user,
    event: 'pro_cta_clicked',
    eventProps: { source: 'header', placement, tier: access?.tier || null, days_left: access?.trial_days_left ?? null },
  });

  const handleDashboardClick = (e) => {
    e.preventDefault();
    openLanding('/dashboard', { user });
  };

  return (
    <header className="terminal-header">
      <button className="hamburger-btn" onClick={onMenuToggle} title="Oldalsáv be/ki" aria-label="Oldalsáv be/ki">☰</button>
      <div className="header-brand">
        {/* Web3 Kurzus márka: ugyanaz a logó és betű (Inter 700), mint a landing és az egyetem fejlécében */}
        <img src="/logo-w3k.png" alt="" className="brand-logo" width="32" height="24" />
        <div className="brand-text">
          <span className="brand-name">Web3 Kurzus</span>
          <span className="brand-sub">Kripto Terminál</span>
        </div>
      </div>
      {/* Piac most (3a): teljes kap. 24 órás változással, forgalom, BTC és ETH dominancia */}
      <div className="header-stats" aria-label="Piac most">
        <StatPill label="Piaci kap." value={totalMktCap ? fmtCompact(totalMktCap) : '—'} change={mktCapChange} />
        <StatPill label="24 ó forgalom" value={volume24h ? fmtCompact(volume24h) : '—'} />
        <StatPill label="BTC dom." value={btcDominance ? fmtShare(btcDominance) : '—'} />
        <StatPill label="ETH dom." value={ethDominance ? fmtShare(ethDominance) : '—'} />
      </div>
      <div className="header-right">
        <LocalSaveMenu />
        {/* Badges:
            PRO subscriber → "PRO"; active trial → "Próba: N nap" (links to /pro);
            otherwise "FREE" + "Plusz →" (Plusz subscriber: "PLUSZ" + "PRO →"), and the trial button for
            whoever never had a trial. TAG users also see "TAG". */}
        {access?.tier === 'affiliate' && <span style={BADGE.tag}>TAG</span>}
        {access?.tier === 'plusz' && !access?.trial_active && <span style={BADGE.plusz}>PLUSZ</span>}
        {access?.tier === 'pro' ? (
          <span style={BADGE.pro}>PRO</span>
        ) : access?.trial_active ? (
          <button
            type="button"
            className="hdr-trial-badge"
            title="PRO előfizetés részletei"
            onClick={() => goPro('trial_badge')}
            style={BADGE.trial}
          >
            ⏰ {trialDaysText(access.trial_days_left)}
          </button>
        ) : access ? (
          <>
            {access.tier !== 'affiliate' && access.tier !== 'plusz' && <span style={BADGE.free}>FREE</span>}
            <TrialStartButton hely="terminal_header" access={access} user={user} onStarted={onTrialStarted} className="trial-start-btn hdr-trial-start">PRO-próba · 14 nap</TrialStartButton>
            {access.tier === 'plusz' ? (
              <button type="button" className="hdr-pro-link" onClick={() => goPro('free_badge')} style={BADGE.proLink}>
                PRO →
              </button>
            ) : (
              <button type="button" className="hdr-pro-link hdr-plusz-link" onClick={goPlusz} style={BADGE.pluszLink}>
                Plusz →
              </button>
            )}
            {/* Desktop entry to TAG activation (mobile has it in the hamburger menu). */}
            {/* Pending request: no new activation offer, just the status (opens the
                modal's pending screen with the submission date). */}
            {onTagClick && (
              <button type="button" className={`hdr-tag-link${tagPending ? ' is-pending' : ''}`} onClick={onTagClick}>
                {tagPending ? 'TAG: feldolgozás alatt' : `TAG · ${TAG_LESSONS} lecke ingyen`}
              </button>
            )}
          </>
        ) : null}
        {onAlertsClick && (
          <button
            type="button"
            className="hdr-bell"
            onClick={onAlertsClick}
            aria-label={alertsBadge > 0 ? `Riasztások – ${alertsBadge} új kioldott` : 'Riasztások'}
            title="Riasztások"
          >
            🔔
            {alertsBadge > 0 && <span className="hdr-bell-badge">{alertsBadge > 99 ? '99+' : alertsBadge}</span>}
          </button>
        )}
        <a
          href="https://web3kurzus.hu/dashboard"
          onClick={handleDashboardClick}
          style={{
            background: 'rgba(0,210,200,0.1)', color: '#00D2C8',
            border: '1px solid rgba(0,210,200,0.3)', borderRadius: '100px',
            padding: '5px 14px', fontSize: '12px', fontWeight: 600,
            textDecoration: 'none', marginRight: '8px',
          }}
        >
          Dashboard →
        </a>
        {displayEmail && (
          <span className="hdr-email-chip hdr-email-chip--desktop" title={userEmail}>{displayEmail}</span>
        )}
        <button
          className="theme-toggle"
          onClick={onToggleTheme}
          title={theme === 'dark' ? 'Váltás világos módra' : 'Váltás sötét módra'}
          aria-label={theme === 'dark' ? 'Váltás világos módra' : 'Váltás sötét módra'}
        >
          {theme === 'dark' ? '☀' : '☾'}
        </button>
        {onSignOut && (
          <button className="hdr-logout-btn" onClick={onSignOut} aria-label="Kilépés" title="Kilépés">×<span className="hdr-logout-txt"> Kilépés</span></button>
        )}
      </div>
    </header>
  );
}

function StatPill({ label, value, change }) {
  const changeColor = change === undefined ? '' : change >= 0 ? 'positive' : 'negative';
  return (
    <div className="stat-pill">
      <span className="stat-label">{label}</span>
      <span className={`stat-value num ${changeColor}`}>{value}</span>
      {change !== undefined && (
        <span className={`stat-change ${changeColor}`}>
          {fmtPct(change)}
        </span>
      )}
    </div>
  );
}

const PILL = { borderRadius: '100px', padding: '3px 10px', fontSize: '11px', fontWeight: 600, whiteSpace: 'nowrap' };
const BADGE = {
  pro:  { ...PILL, color: '#A97BFF', background: 'rgba(140,80,255,0.1)', border: '1px solid rgba(140,80,255,0.3)' },
  tag:  { ...PILL, color: '#00D2C8', background: 'rgba(0,210,200,0.1)', border: '1px solid rgba(0,210,200,0.3)' },
  // Plusz: a landing --tier-plusz tokenje (kitöltött akcentus-cián, sötét betű)
  plusz: { ...PILL, color: '#0a0f1e', background: '#00D2C8', border: '1px solid #00D2C8', fontWeight: 700 },
  free: { ...PILL, color: 'var(--text2)', background: 'var(--surface2)', border: '1px solid var(--border2)' },
  trial: { ...PILL, color: '#fbbf24', background: 'rgba(251,191,36,0.1)', border: '1px solid rgba(251,191,36,0.4)', cursor: 'pointer', fontFamily: 'inherit' },
  proLink: { ...PILL, color: '#0a0f1e', background: '#A97BFF', border: 'none', cursor: 'pointer', fontFamily: 'inherit', fontWeight: 700 },
  // Plusz-gomb: a Plusz színe (mint a PLUSZ jelvény)
  pluszLink: { ...PILL, color: '#0a0f1e', background: '#00D2C8', border: 'none', cursor: 'pointer', fontFamily: 'inherit', fontWeight: 700 },
};
